import axiosInstance from "./global-instance";
import createScopedApi from "./createScopedApi";
import { slotsApiUrl } from "../constants/url-constants";

const BASE_API_URL = `${slotsApiUrl()}`;

export default createScopedApi(BASE_API_URL, axiosInstance);
